import React from 'react';

function LegendMarker({ color }) {
  return <div className="comps-chart__legend-marker" style={{ backgroundColor: color }}></div>;
}

export default LegendMarker;
